export enum TypeIcon {
  CALENDAR = 'CALENDAR',
  CHECK = 'CHECK',
  FOLDER = 'FOLDER',
}
